// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../registration-vue/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".country-popover .arrow{display:none}.language-header.min-height{min-height:3.5em}", ""]);
// Exports
module.exports = exports;
